module.exports = __webpack_public_path__ + "static/media/lock_icon.1cc9b293.svg";